import { isIosSafariNotStandalone } from 'handlers/isIosSafariNotStandalone'

export type NotificationsSupportStatus =
  | 'ready'
  /** iOS Safari во вкладке: Web Push / Notification только после установки PWA */
  | 'needs_ios_pwa_install'
  /** Браузер без Notification API */
  | 'unsupported_notification_api'
  /** Есть Notification, но нет PushManager / SW (фоновый push недоступен) */
  | 'push_unsupported'

/**
 * Определяет, можно ли включить уведомления в текущем окружении (Safari/iOS учтены).
 */
export const getNotificationsSupportStatus =
  (): NotificationsSupportStatus => {
    if (typeof window === 'undefined') {
      return 'unsupported_notification_api'
    }

    // На iPhone/iPad во вкладке Safari API часто отсутствует до установки на Домой
    if (isIosSafariNotStandalone()) {
      return 'needs_ios_pwa_install'
    }

    const hasNotificationApi =
      typeof Notification !== 'undefined' || 'Notification' in window

    if (!hasNotificationApi) {
      return 'unsupported_notification_api'
    }

    const hasPushManager = 'PushManager' in window
    const hasServiceWorker = 'serviceWorker' in navigator
    if (!hasPushManager || !hasServiceWorker) {
      return 'push_unsupported'
    }

    return 'ready'
  }
